<template>
	<div class="z-box-wrap">
		<ul class="head">
			<li :class="{active:activeIndex==0}" @click="activeIndex = 0">发布审核{{ `(${release.total})` }}</li>
			<li :class="{active:activeIndex==1}" @click="activeIndex = 1">取消审核{{ `(${cancel.total})` }}</li>
			<li :class="{active:activeIndex==2}" @click="activeIndex = 2">投诉审核{{ `(${complain.total})` }}</li>
		</ul>
	
		<div class="main">
			<!-- 发布申请 -->
			<div class="tab-div" v-show="activeIndex == 0">
				<div class="search-head">
					<span>状态：</span>
					<el-select class="top-choose" v-model="release.status" placeholder="请选择" @change="changeType('release')">
						<el-option v-for="item in apply.statusOption" :key="item.id" :value="item.id" :label="item.label">
						</el-option>
					</el-select>
					<span>申请时间：</span>
					<el-date-picker class="top-choose" v-model="release.date_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="release.date_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<span>关键字：</span>
					<el-input class="top-choose"  v-model="release.keyStr" placeholder="任务编号或名称"></el-input>
					<div class='front-btn green shift'  @click="releaseSearch()">查询</div>
				</div>

				<div class="list">
					<div class="list-head" :style="{'padding-right':padd_0}">
						<div>申请时间
							<div class="angle-wrap">
								<i class="el-icon-caret-top" :class="{active:release.date_sort == 'createdAt_asc'}" @click="()=>{release.date_sort='createdAt_asc'; releaseSearch()}"></i>
								<i class="el-icon-caret-bottom" :class="{active:release.date_sort == 'createdAt_desc'}" @click="()=>{release.date_sort='createdAt_desc'; releaseSearch()}"></i>
							</div>
						</div>
						<div>发布BU</div>
						<div>任务编号</div>
						<div>任务名称</div>
						<div v-show="release.status !='1'">审核人</div>
						<div v-show="release.status !='1'">审核时间</div>
						<div>状态</div>
						<div>操作</div>
					</div>	
					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in releaseList" :key="item.id">
							<div>{{ item.created_at | placeholder }}</div>
							<div class="overhide" :title="item.pub_bu_name">{{ item.pub_bu_name }}</div>
							<div @click="openDetail(item)">{{ item.code }}</div>
							<div class="ellipsis" :title="item.task_name">{{ item.task_name }}</div>
							<div v-show="release.status !='1'" class="overhide" :title="item.real_name">{{ item.real_name }}</div>
							<div v-show="release.status !='1'">{{ item.updated_at }}</div>
							<div :class="{danger:release.status == '1'}">{{ statusText(item.status) }}</div>
							<div @click="showSlider(item,'release')" :class="{'orange-text':item.status == 1}">{{ release.status | applyStatus }}</div>
						</div>
						<z-noData :list="releaseList"></z-noData>
					</z-scrollDiv>	
				</div>

				<z-pagination class="inside" @getPage="releaseSearch" :data='release.data'></z-pagination>
			</div>

			<!-- 取消申请 -->
			<div class="tab-div" v-show="activeIndex == 1">
				<div class="search-head">
					<span>状态：</span>
					<el-select class="top-choose" v-model="cancel.status" placeholder="请选择" @change="changeType('cancel')">
						<el-option v-for="item in apply.statusOption" :key="item.id" :value="item.id" :label="item.label">
						</el-option>
					</el-select>
					<span>申请时间：</span>
					<el-date-picker class="top-choose" v-model="cancel.date_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="cancel.date_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<span>关键字：</span>
					<el-input class="top-choose"  v-model="cancel.keyStr" placeholder="任务编号或名称"></el-input>
					<div class="front-btn green shift"  @click="cancelSearch()">查询</div>
				</div>

				<div class="list">
					<div class="list-head" :style="{'padding-right':padd_1}">
						<div>申请时间
							<div class="angle-wrap">
								<i class="el-icon-caret-top" :class="{active:cancel.date_sort == 'createdAt_asc'}" @click="()=>{cancel.date_sort='createdAt_asc'; cancelSearch()}"></i>
								<i class="el-icon-caret-bottom" :class="{active:cancel.date_sort == 'createdAt_desc'}" @click="()=>{cancel.date_sort='createdAt_desc'; cancelSearch()}"></i>
							</div>
						</div>
						<div>申请BU</div>
						<div>任务编号</div>
						<div>任务名称</div>
						<div v-show="cancel.status !='1'">审核人</div>
						<div v-show="cancel.status !='1'">审核时间</div>
						<div>状态</div>
						<div>操作</div>
					</div>	
					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in cancelList" :key="item.id">
							<div>{{ item.created_at }}</div>
							<div class="overhide" :title="item.sub_bu_name">{{ item.sub_bu_name }}</div>
							<div @click="openDetail(item)">{{ item.code }}</div>
							<div class="ellipsis" :title="item.task_name">{{ item.task_name }}</div>
							<div v-show="cancel.status !='1'" class="overhide" :title="item.real_name">{{ item.real_name }}</div>
							<div v-show="cancel.status !='1'">{{ item.updated_at }}</div>							
							<div :class="{danger:cancel.status == '1'}">{{ statusText(item.status) }}</div>
							<div @click="showSlider(item,'cancel')" :class="{'orange-text':item.status == 1}">{{ item.status | applyStatus }}</div>
						</div>
						<z-noData :list="cancelList"></z-noData>
					</z-scrollDiv>	
				</div>

				<z-pagination class="inside" @getPage="cancelSearch" :data='cancel.data'></z-pagination>
			</div>

            <!-- 投诉申请 -->
            <div class="tab-div" v-show="activeIndex == 2">
				<div class="search-head">
					<span>状态：</span>
					<el-select class="top-choose" v-model="complain.status" placeholder="请选择" @change="changeType('complain')">
						<el-option v-for="item in apply.statusOption" :key="item.id" :value="item.id" :label="item.label">
						</el-option>
					</el-select>
					<span>申请时间：</span>
					<el-date-picker class="top-choose" v-model="complain.date_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="complain.date_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<!-- <span>关键字：</span>
					<el-input class="top-choose"  v-model="complain.keyStr" placeholder="编号或任务名称"></el-input> -->
					<div class="front-btn green shift"  @click="complainSearch()">查询</div>
				</div>

				<div class="list">
					<div class="list-head" :style="{'padding-right':padd_2}">
						<div>申请时间
							<div class="angle-wrap">
								<i class="el-icon-caret-top" :class="{active:complain.date_sort == 'createdAt_asc'}" @click="()=>{complain.date_sort='createdAt_asc'; complainSearch()}"></i>
								<i class="el-icon-caret-bottom" :class="{active:complain.date_sort == 'createdAt_desc'}" @click="()=>{complain.date_sort='createdAt_desc'; complainSearch()}"></i>
							</div>
						</div>
						<!-- <div>投诉编号</div> -->
						<div>投诉BU</div>
						<div>任务编号</div>
						<div>任务名称</div>
						<div v-show="complain.status !='1'">审核人</div>
						<div v-show="complain.status !='1'">审核时间</div>
						<div>状态</div>
						<div>操作</div>
					</div>	
					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in complainList" :key="item.id">
							<div>{{ item.created_at }}</div>
							<!-- <div>{{ item.code }}</div> -->
							<div class="overhide" :title="item.pub_bu_name">{{ item.pub_bu_name }}</div>
							<div @click="openDetail(item)">{{ item.code }}</div>
							<div class="ellipsis" :title="item.task_name">{{ item.task_name }}</div>
							<div v-show="complain.status !='1'" class="overhide" :title="item.real_name">{{ item.real_name }}</div>
							<div v-show="complain.status !='1'">{{ item.updated_at }}</div>	
							<div :class="{danger:complain.status == '1'}">{{ statusText(item.status) }}</div>
							<div @click="showSlider(item,'complain')" :class="{'orange-text':item.status == 1}">{{ item.status | applyStatus }}</div>
						</div>
						<z-noData :list="complainList"></z-noData>
					</z-scrollDiv>	
				</div>

				<z-pagination class="inside" @getPage="complainSearch" :data='complain.data'></z-pagination>
			</div>
		</div>

		<!-- 滑页 -->
		<sliderPage :title="slider_title" :sliderArg="sliderArg" @close="sliderClear">
			<!-- 发布申请 -->
			<sliderRelease v-if="activeIndex == 0" :sliderArg="sliderArg" :data="slider_data" :examine="sub"></sliderRelease>
			<!-- 取消申请 -->
			<sliderCancel v-if="activeIndex == 1" :sliderArg="sliderArg" :data="slider_data" :examine="sub"></sliderCancel>
			<!-- 投诉申请 -->
			<sliderComplain v-if="activeIndex == 2" :sliderArg="sliderArg" :data="slider_data" :examine="sub"></sliderComplain>
			

			<!-- 投诉审核 -->
			<!-- <sliderAdd v-if="activeIndex == 0" :sliderArg="sliderArg" :data="slider_data" :examine="sub"></sliderAdd> -->
			<!-- 调岗申请 -->
			<!-- <sliderMod v-if="activeIndex == 1" :sliderArg="sliderArg" :data="slider_data" :examine="sub"></sliderMod> -->

			<!-- 分支 -->
			<div slot="pass" class="form-tip">
				<div class="text">是否确认提交处理结果</div>
				<div class="btns">
					<el-button @click="sliderArg.insideFlag = false">取 消</el-button>
					<el-button type="primary" v-show="activeIndex == 0" @click="confirmRealease(slider_data.id)">确定</el-button>
					<el-button type="primary" v-show="activeIndex == 1" @click="confirmCancel(slider_data.id)">确定</el-button>
					<el-button type="primary" v-show="activeIndex == 2" @click="confirmComplain(slider_data.id)">确定</el-button>
				</div>
			</div>

			<div slot="notpass" class="form-tip">
				<div class="text">是否确认提交处理结果</div>
				<div class="btns">
					<el-button @click="sliderArg.insideFlag = false">取 消</el-button>
					<el-button type="primary" v-show="activeIndex == 0" @click="refuseRealease(slider_data.id)">确定</el-button>
					<el-button type="primary" v-show="activeIndex == 1" @click="refuseCancel(slider_data.id)">确定</el-button>
					<el-button type="primary" v-show="activeIndex == 2" @click="refuseComplain(slider_data.id)">确定</el-button>
				</div>
			</div>



			
		</sliderPage>

		<!-- 详情弹窗 -->
		<z-windowPop @cancel="pop.show = false" :show="pop.show" :height="'80%'" :noBtns="true" :title="`任务编号：${pop.title}`" :black="true">
            <readDetail :taskId="pop.id"></readDetail>
        </z-windowPop>


	</div>
</template>

<script>
	import sliderPage from "src/components/slider/sliderPage.vue"
    import readDetail from "src/components/read-taskDetail.vue";
	import sliderRelease from "src/components/slider/slider_releaseTask.vue"
	import sliderCancel from "src/components/slider/slider_cancelTask.vue"
	import sliderComplain from "src/components/slider/slider_complainTask.vue"


	import { mapState } from "vuex";
	import { changeType } from 'src/control/common.js';  //公共方法



	export default {
		components: {
			sliderPage,
			readDetail,
			sliderRelease,
			sliderCancel,
			sliderComplain,
		},
		data() {
			return {
				activeIndex: 0,  //tab 序号
				sliderArg:{
					flag:false,
					inside_index:0,
					insideFlag:false,
				},
				slider_data:{},  //滑页数据
				task_data:{},   //详情数据
				pop:{          //详情弹窗
					show:false,
					id:"",
					title:"",
				},
				// showTaskFlag:false,  
				sub:{
					result:"",   //审核说明
				},
				
				// **发布任务**
				release:{  
					status:"1",  //状态
					date_start:"",
					date_end:"",
					date_sort:"createdAt_desc",
					keyStr:"",

					total: 0,   //发布审核 数量
					data:{},
				},

				//**取消任务**
				cancel:{
					status:"1",  //状态
					date_start:"",
					date_end:"",
					date_sort:"createdAt_desc",
					keyStr:"",
					
					total:0,
					data:{},
				},

				//**投诉任务**
				complain:{
					status:"1",  //状态
					date_start:"",
					date_end:"",
					date_sort:"createdAt_desc",
					// keyStr:"",

					total:0,
					data:{},
				},
			}
		},
		computed:{
			...mapState(["picker_special","apply"]),
			slider_title(){  //滑页标题
				switch (this.activeIndex) {
					case 0:
						return "发布申请"	
					case 1:
						return "取消申请"
					case 2:
						return "投诉申请"
				}
			},
			releaseList(){  //发布任务列表
				return this.release.data.list;
			},
			cancelList(){
				return this.cancel.data.list;
			},
			complainList(){
				return this.complain.data.list;
			},
			padd_0(){
				return this.releaseList && this.releaseList.length>=8?"17px":0;
			},
			padd_1(){
				return this.cancelList && this.cancelList.length>=8?"17px":0;
			},
			padd_2(){
				return this.complainList && this.complainList.length>=8?"17px":0;
			},
		},
		
		watch:{
			"sliderArg.flag"(val){
				if(val == false){
					this.slider_data = {};
				}
			}
		},
		
		created(){
			this.firstGet();
		},

		methods: {
			changeType,
			// 首次加载
			firstGet(){
				this.releaseFresh({"order_str":"createdAt_desc"},function(data){
					this.release.total = data.total;
				});
				
				this.cancelFresh({order_str:"createdAt_desc"},function(data){
					this.cancel.total = data.total;
				});

				this.complainFresh({order_str:"createdAt_desc"},function(data){
					this.complain.total = data.total;
				});
				
			},

			//详情弹窗
			openDetail(item){
				this.pop.id = item.task_detail_id;
				this.pop.title = item.code;
				this.pop.show = true;
			},
			statusText(status){
				switch (parseInt(status)) {
					case 1:
						return "待处理"
					case 2:
						return "审核通过"
					case 3:
						return "审核失败"
				}
			},

			// ***滑页相关***
			showSlider(item,str){
				let url = `api/admin/task_admin_review/${item.task_detail_id}`;
				this.$http.get(url,{params:{apply_type:str}}).then(res=>{
					if(res.status == 200){
						this.slider_data = res.res_data;
						this.sliderArg.flag = true;
					}
				});
				
			},
			sliderClear(){
				this.sub.result = "";
			},

			
			// ***发布审核相关 ******
			releaseFresh(obj = {},func){
				let url = "api/admin/task_admin_review";
				let config = {params:obj};

				this.$http.get(url,config).then(res=>{
					if(res.status == 200){
						this.release.data = res.res_data;
						func && func.call(this,res.res_data);
					}
				})
			},
			releaseSearch(page){
				let obj = {
					page:page,
					status:this.release.status,
					start_date:this.release.date_start,
					end_date:this.release.date_end,
					order_str:this.release.date_sort,
					keyword:this.release.keyStr,
				};
				this.releaseFresh(obj);
			},


			confirmRealease(id){  //通过审核
				let url = `api/admin/task_admin_review/${id}/pass`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("任务发布已过审");
	
						this.releaseFresh({"order_str":"createdAt_desc"},function(data){
							this.release.total = data.total;
						});
	
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},
			refuseRealease(id){  //驳回审核
				let url = `api/admin/task_admin_review/${id}/reject`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("任务发布已驳回");
	
						this.releaseFresh({"order_str":"createdAt_desc"},function(data){
							this.release.total = data.total;
						});
	
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},

			// ***取消任务审核相关**
			cancelFresh(obj = {},func){
				let url = "api/admin/task_cancel_detail";
				let config = {params:obj};

				this.$http.get(url,config).then(res=>{
					if(res.status ==200){
						this.cancel.data = res.res_data;
						func && func.call(this,res.res_data);
					}
				});
			},
			cancelSearch(page){
				let obj = {
					page:page,
					status:this.cancel.status,
					start_date:this.cancel.date_start,
					end_date:this.cancel.date_end,
					order_str:this.cancel.date_sort,
					keyword:this.cancel.keyStr,
				};
				this.cancelFresh(obj);
			},

			confirmCancel(id){  //通过取消申请
				let url = `api/admin/task_cancel_detail/${id}/pass`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("取消申请已通过");

						this.cancelFresh({order_str:"createdAt_desc"},function(data){
							this.cancel.total = data.total;
						});

						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();

					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},
			refuseCancel(id){  //驳回取消申请
				let url = `api/admin/task_cancel_detail/${id}/reject`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("取消申请已驳回");

						this.cancelFresh({order_str:"createdAt_desc"},function(data){
							this.cancel.total = data.total;
						});

						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},

			// ***投诉任务相关***
			complainFresh(obj = {},func){
				let url = "api/admin/task_comp_detail";
				let config = {params:obj};

				this.$http.get(url,config).then(res=>{
					if(res.status == 200){
						this.complain.data = res.res_data;
						func && func.call(this,res.res_data);
					}
				})
			},
			complainSearch(page){
				let obj = {
					page:page,
					status:this.complain.status,
					start_date:this.complain.date_start,
					end_date:this.complain.date_end,
					order_str:this.complain.date_sort,
					// keyword:this.complain.keyStr,
				};
				this.complainFresh(obj);
			},

			confirmComplain(id){  //投诉申请通过
				let url = `api/admin/task_comp_detail/${id}/pass`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("投诉申请已通过");
	
						this.complainFresh({order_str:"createdAt_desc"},function(data){
							this.complain.total = data.total;
						});
	
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});

			},
			refuseComplain(id){  //驳回投诉
				let url = `api/admin/task_comp_detail/${id}/reject`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("投诉申请已驳回");
	
						this.complainFresh({order_str:"createdAt_desc"},function(data){
							this.complain.total = data.total;
						});
	
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	// @import "~src/assets/less/var.less";
	@import "~src/assets/less/application.less";

	.list-head >div,.list-detail .item>div{
        &:nth-of-type(1){
            width: 15%;
        }
        &:nth-of-type(2){
			width: 13%;
        }
        &:nth-of-type(3){
            width: 10%;
		}
        &:nth-of-type(4){
            width: 18%;
		}
        &:nth-of-type(5){
            width: 10%;
		}
        &:nth-of-type(6){
            width: 14%;
		}
        &:nth-of-type(7){
            width: 10%;
		}
        &:nth-of-type(8){
            width: 10%;
		}
	}

	.list-detail .item>div{
		&:last-of-type,&:nth-of-type(3){
			color: @focus-c;
			cursor:pointer;
		}
	}

	.tab-div:nth-child(3){
		.list-head >div,.list-detail .item>div{
			&:nth-of-type(1){
				width: 13%;
			}
			&:nth-of-type(2){
				width: 10%;
			}
			&:nth-of-type(3){
				width: 10%;
			}
			&:nth-of-type(4){
				width: 10%;
			}
			&:nth-of-type(5){
				width: 14%;
			}
			&:nth-of-type(6){
				width: 13%;
			}
			&:nth-of-type(7){
				width: 10%;
			}
			&:nth-of-type(8){
				width: 10%;
			}
			&:nth-of-type(9){
				width: 10%;
			}
			
			
		}
		.list-detail .item>div{
			// &:nth-of-type(3){
			// 	color: #999;
			// 	cursor:default;
			// }
			&:nth-of-type(3){
				color: @focus-c;
				cursor:pointer;
			}

		}
	}
</style>








// WEBPACK FOOTER //
// page-task-examine.vue?655744e6